import React, { useEffect, useState } from "react";
import "../../css/ShopRegister.css";
import ngeohash from "ngeohash";
import {
	registerUser,
	setValueToDatabase,
} from "../../apiIntegration/databaseConnection";
import { toast, ToastContainer } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { categoriesList } from "../../constant/categories";
import { getShopDetailsFromLocalStorage } from "../../localstorage";
import ShopLocationPicker from "./NavigationMap/ShopLocationPicker";

export default function ShopRegister() {
	const [form, setForm] = useState({
		shopName: "",
		ownerName: "",
		email: "",
		phone: "",
		password: "",
		confirmPassword: "",
		category: [],
		address: "",
		city: "",
		state: "",
		pincode: "",
		openingTime: "",
		closingTime: "",
	});

	const [loading, setLoading] = useState(false);
	const [locationData, setLocation] = useState({
		latitude: null,
		longitude: null,
	});
	const [showMap, setShowMap] = useState(false);
	const [showUnauthorizedPopup, setShowUnauthorizedPopup] = useState(false);

	const shopDetails = getShopDetailsFromLocalStorage();
	const userId = shopDetails?.shopId;

	const navigate = useNavigate();

	useEffect(() => {
		if (userId !== "fXsOXnt8mfNQyX5FaoBnqk7Z61w1") {
			setShowUnauthorizedPopup(true);
		}
	}, [navigate, userId]);

	/* ======================================================
   PREVENT FORM RENDER
====================================================== */

	/* ================= INPUT ================= */
	const handleChange = (e) => {
		setForm({ ...form, [e.target.name]: e.target.value });
	};

	const handleLocationChange = (newLocation) => {
		setLocation({
			latitude: newLocation.latitude,
			longitude: newLocation.longitude,
		});
	};


	/* ================= VALIDATION ================= */
	const validate = () => {
		if (!form.shopName || !form.ownerName)
			return alert("Fill basic details");
		if (!form.email || !form.password) return alert("Fill credentials");
		if (form.password !== form.confirmPassword)
			return alert("Passwords do not match");
		if (!locationData) return alert("Please select location from map");
		return true;
	};

	/* ================= REGISTER ================= */
	const handleRegister = async () => {
		if (!validate()) return;

		try {
			setLoading(true);

			// ✅ STEP 1: Create Auth User
			const userCredential = await registerUser(
				form.email,
				form.password,
			);

			const uid = userCredential.user.uid;

			const geoHash = ngeohash.encode(locationData.latitude, locationData.longitude);

			const shopData = {
				shopId: uid,
				shopName: form.shopName.toLowerCase(),
				ownerName: form.ownerName,
				email: form.email,
				phone: form.phone,

				category: form.category,

				address: {
					city: form.city.toLowerCase(),
					state: form.state.toLowerCase(),
					pincode: form.pincode,
				},

				location: {
					lat: locationData.latitude,
					lng: locationData.longitude,
				},

				geoHash,

				openingTime: form.openingTime,
				closingTime: form.closingTime,

				isActive: true,
				createdAt: new Date().toISOString(),
			};

			await setValueToDatabase(`shops/${uid}`, shopData);
			toast.success("Shop Registered Successfully 🚀");
			setTimeout(() => {
				navigate("/login-screen");
			}, 1000);
		} catch (err) {
			console.error(err);
			toast.error("Shop Registered Failed");
		} finally {
			setLoading(false);
		}
	};

	if (showUnauthorizedPopup) {
		return (
			<div className="unauthorized-container">
				<div className="unauthorized-card">
					<h4 className="pt-5 pb-4">Shop Onboarding Restricted</h4>
					<p>Only sales team can onboard the shop.</p>
					<p>
						Please contact us on <b>8983222814</b>
					</p>

					<button
						className="send-btn w-75"
						onClick={() => navigate("/contact-support")}
					>
						Contact Us
					</button>
				</div>
			</div>
		);
	}

	return (
		<div className="register-container">
			<ToastContainer />

			<div className="register-card">
				<h2>Register Your Shop</h2>

				{/* BASIC */}
				<input
					name="shopName"
					placeholder="Shop Name"
					onChange={handleChange}
				/>
				<input
					name="ownerName"
					placeholder="Owner Name"
					onChange={handleChange}
				/>
				<input
					name="phone"
					placeholder="Phone"
					onChange={handleChange}
				/>
				<input
					name="email"
					placeholder="Email"
					onChange={handleChange}
				/>

				{/* PASSWORD */}
				<input
					type="password"
					name="password"
					placeholder="Password"
					onChange={handleChange}
				/>
				<input
					type="password"
					name="confirmPassword"
					placeholder="Confirm Password"
					onChange={handleChange}
				/>

				{/* CATEGORY */}
				<div className="category-box">
					<p>Select Categories</p>
					<div className="category-list">
						<select
							name="category"
							className="form-control custom-input"
							onChange={handleChange}
						>
							{categoriesList.map((c) => (
								<option key={c.name}>
									<i className={`fa-solid ${c.icon}`}>
										{c.name}{" "}
									</i>
								</option>
							))}
						</select>
					</div>
				</div>

				{/* ADDRESS */}
				<input
					name="address"
					placeholder="Full Address"
					onChange={handleChange}
				/>
				<input name="city" placeholder="City" onChange={handleChange} />
				<input
					name="state"
					placeholder="State"
					onChange={handleChange}
				/>
				<input
					name="pincode"
					placeholder="Pincode"
					onChange={handleChange}
				/>

				<div className="register-section pt-2">
					<ShopLocationPicker
						location={locationData}
						onLocationChange={handleLocationChange}
					/>
				</div>
				{/* SUBMIT */}
				<button
					className="submit-btn"
					onClick={handleRegister}
					disabled={loading}
				>
					{loading ? "Registering..." : "Register Shop"}
				</button>
			</div>
		</div>
	);
}
